import {
  Component,
  effect,
  HostListener,
  input,
  output,
  signal,
} from '@angular/core';
import { Category } from '../../models/category.model';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-category-filter',
  imports: [NgTemplateOutlet],
  templateUrl: './category-filter.component.html',
  styleUrl: './category-filter.component.scss',
})
export class CategoryFilterComponent {
  data = input.required<Category[]>();
  open = input<boolean>(false);
  name = input<string>('');

  toggled = output<boolean>();
  selected = output<{ id: string }>();

  expanded = signal<Set<string>>(new Set<string>());

  private _lock = effect(() => {
    document.documentElement.style.overflow = this.open() ? 'hidden' : '';
  });

  isLeaf = (n: Category) => !n.categories || n.categories.length === 0;

  isOpen(id: string) {
    return this.expanded().has(id);
  }

  toggleNode(id: string) {
    const next = new Set(this.expanded());
    next.has(id) ? next.delete(id) : next.add(id);
    this.expanded.set(next);
  }

  togglePanel(next?: boolean) {
    const v = next ?? !this.open();
    this.toggled.emit(v);
  }

  nextPath(path: string[], name: string) {
    return [...path, name];
  }

  onLeaf(node: Category) {
    this.selected.emit({ id: node.id });
    this.toggled.emit(false);
  }

  countItems(node: any): number {
    if (!node) return 0;

    const count = (node.auctionsCount || node.codesCount) ;
    return count >= 0 ? count : 0;
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape' && this.open()) this.toggled.emit(false);
  }
}
